export const eur0 = (n: number) =>
  "€" + n.toLocaleString("en-IE", { maximumFractionDigits: 0 });

export const formatCurrency = (v?: number, currency: string = "EUR") =>
  v == null
    ? "—"
    : new Intl.NumberFormat(undefined, {
        style: "currency",
        currency,
        maximumFractionDigits: 0,
      }).format(v);

export const formatPercent = (v?: number) =>
  v == null ? "—" : `${(v * 100).toFixed(1)}%`;

export const isoToDate = (s?: string) =>
  s ? new Date(s).toLocaleDateString() : "—";

export const formatDateTime = (
  isoString: string | null | undefined,
): string => {
  if (!isoString) return "-";

  try {
    const date = new Date(isoString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  } catch (error) {
    return "-";
  }
};
